angular
  .module('data-ng-path-item')
  .constant('ItemDTD', {
    id: 'key',
    range: 'key',
    nk: 'string',
    title: 'string',
    text: 'html',
    short_title: 'string',
    short_text: 'html',
    didyouknow: 'html',
    poll: {
      optional: true,
      type: 'integer'
    },
    actions_min: 'integer',
    actions_max: 'integer',
    options: 'object',
    help_text: 'html',
    sub_title: 'html',
    show: 'boolean',
    _task: {
      optional: true,
      type: '*'
    },
    _parent: {
      optional: true,
      type: '*'
    },
    children: 'array',
    _options: {
      optional: true,
      type: 'object'
    },
    item_type: {
      type: 'enum',
      typeDef: 'ItemTypeEnum'
    },
    presenter: {
      type: 'enum',
      typeDef: 'ItemPresenterEnum'
    },
    location_group: 'key',
    topic_id: 'id',
    link_to_appt_scheduling: 'boolean',
    _presenterMode: {
      optional: true,
      type: 'enum',
      typeDef: 'PresenterModeEnum',
      defaultValue: undefined
    }
  })
  .factory('ItemBuilderDTD', function (ItemDTD) {
    // DEPRECATED ItemDTD
    return ItemDTD;
  })
  .factory('ItemBuilder', function ItemBuilder(Interface, ItemBuilderDTD, ItemPresenterEnum) {
    var overrideGenericPresenterWithItemType = function overrideGenericPresenterWithItemType(item, data) {
      if (ItemPresenterEnum.isEqual('DETAILS', item.presenter) && !!item.item_type) {
        item.presenter = ItemPresenterEnum.key(data.item_type);
      }
    };

    var forceBoldTypeForStrongTag = function forceBoldTypeForStrongTag(text) {
      // DEPRECATED leaving font-bold in case the editor has not upgraded to the latest typography rules
      return text.replace(/<strong>/g, '<strong class="font-bold text-bold">');
    };

    return function ItemDTO(data) {
      Interface.implement(ItemBuilderDTD, data, this);
      overrideGenericPresenterWithItemType(this, data);
      // NOTE: The Froala editor uses a <strong> HTML tag for bold text, which EAB UI overrides to make it not bold
      this.text = forceBoldTypeForStrongTag(this.text);
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/builders/item_builder.js